<script setup lang="ts">
defineProps<{
    message: string;
}>();
</script>

<template>
    <div class="empty-state">
        <p class="empty-state__message">{{ message }}</p>
    </div>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 20rem;
    text-align: center;
    padding: $portal-section-py $portal-section-px;
    background: $portal-bg;
    border-radius: $portal-card-radius;

    &__message {
        font-size: $text-portal-body;
        color: $portal-text-mid;
        max-width: 24rem;
        line-height: 1.5;
    }
}
</style>
